import throttle from 'throttleit'
import { mapState } from 'vuex'

import { trackResize } from '@tracking/events'

const THROTTLE_WAIT = 700

export default {
  mounted() {
    this.updateBreakpoint()
    window.addEventListener('resize', this.delayUpdateBp)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.delayUpdateBp)
  },
  computed: {
    ...mapState({
      layoutBreakpoint: (state) => state.layout.breakpoint,
      layoutRule: (state) => state.layout.rule,
    }),
  },
  methods: {
    delayUpdateBp: throttle(function throttledUpdateBreakpoint() {
      this.updateBreakpoint()
    }, THROTTLE_WAIT),

    updateBreakpoint() {
      this.$store.dispatch('updateBreakpoint')
      trackResize({
        breakpointName: this.layoutBreakpoint,
        breakpointRule: this.layoutRule,
      })
    },
  },
}
